/** Minimum table width so percentage columns do not collapse in the empty-state frame. */
export const EXPERT_PROFIT_AND_LOSS_TABLE_MIN_WIDTH = '960px'

/** Shared width for N, N-1, variance amount and variance percentage columns. */
export const EXPERT_PROFIT_AND_LOSS_AMOUNT_COLUMN_WIDTH = '12%'

export const EXPERT_PROFIT_AND_LOSS_COLUMN_WIDTHS = {
  item: '52%',
  amount: EXPERT_PROFIT_AND_LOSS_AMOUNT_COLUMN_WIDTH,
} as const
